import { configureStore } from '@reduxjs/toolkit';
import { captureError } from '../utils/errorHandling';
import { ActionType } from './ActionTypes';
import { Action, GlobalState, Preferences, rootReducer } from './RootReducer';

export const store = configureStore<GlobalState, Action>({
  reducer: rootReducer,
});

const lsPreferences = localStorage.getItem('preferences');

if (lsPreferences) {
  try {
    const preferences = JSON.parse(lsPreferences) as Preferences;

    store.dispatch({
      preferences,
      type: ActionType.PreferenceUpdate,
    });
  } catch (error) {
    captureError(error as Error);
    localStorage.removeItem('preferences');
  }
}
